export default "/institutions/safra.svg";